import React, { ReactElement } from 'react'
import { MemberEditPage } from 'src/ui/page/common/member/details/MemberEditPage'

export const ServicerEditPage = (): ReactElement => {
  return <MemberEditPage isServicer />
}
